module.exports = __webpack_public_path__ + "img/PM_A03_front_en.4f4774c4.png";